import CommentsForm from './CommentsForm'

export default CommentsForm
